import type { RailDisplayStatus } from "./rail-model";

export type WorkflowPillClass = "pill-done" | "pill-client" | "pill-team" | "pill-locked";

const DONE_STATES = new Set(["done", "approved", "published", "transferred", "processed"]);
const CLIENT_STATES = new Set([
  "next",
  "review",
  "ready",
  "update",
  "awaiting_client",
  "awaiting_approval",
  "testing"
]);
const TEAM_STATES = new Set(["working", "preparing"]);

const RAIL_PILL_BY_STATUS: Record<RailDisplayStatus, WorkflowPillClass> = {
  locked: "pill-locked",
  on_deck: "pill-client",
  review: "pill-client",
  waiting_apple: "pill-team",
  working: "pill-team",
  done: "pill-done",
  open: "pill-client",
  testing: "pill-client",
  feedback: "pill-client",
  client: "pill-client"
};

export function workflowPillClass(state: string | null | undefined): WorkflowPillClass {
  const normalized = state ?? "";
  if (DONE_STATES.has(normalized)) return "pill-done";
  if (CLIENT_STATES.has(normalized)) return "pill-client";
  if (TEAM_STATES.has(normalized)) return "pill-team";
  return "pill-locked";
}

export function railPillClass(status: RailDisplayStatus): WorkflowPillClass {
  return RAIL_PILL_BY_STATUS[status];
}
